import {
  Backdrop, Button, Card, CardActions, CardContent, CardHeader, Checkbox, CircularProgress, Container,
  Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, Grid, IconButton, InputAdornment, Paper,
  Radio, Slide, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField
} from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import CloseIcon from '@material-ui/icons/Close';
import CropFreeIcon from '@material-ui/icons/CropFree';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DomainIcon from '@material-ui/icons/Domain';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import SearchIcon from '@material-ui/icons/Search';
import TouchAppIcon from '@material-ui/icons/TouchApp';
import UpdateIcon from '@material-ui/icons/Update';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { BsFileDiff } from "react-icons/bs";
import { FiSend } from "react-icons/fi";
import { GiTemporaryShield } from "react-icons/gi";
import BarcodeVoice from "src/assets/sound/Bip.mp3";
import ErrorVoice from "src/assets/sound/Error.mp3";
import { CustomTableCell } from 'src/components/CustomTableCell';
import GenericBulten from 'src/components/GenericBulletin';
import Page from 'src/components/Page';
import AddressSearch from 'src/components/Selects/AddressSearch';
import axios from "src/utils/axios";
import { CreateWareHouseAddress, GetLocalInvoice, getUser, GetWarehouseAddress, SaveLocalInvoiceAddress, sc } from 'src/utils/Common';


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  container: {
    maxHeight: 497,
    minHeight: 497,
  },
  button: {
    margin: theme.spacing(0.2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function LoginInvoice() {
  const classes = useStyles();
  const [previous, setPrevious] = React.useState({});
  const [Loading, setLoading] = useState(true);
  const [Invoice, setInvoice] = useState([]);
  const [rowsLogin, setrowsLogin] = useState([]);
  const [DistinctInvoice, setDistinctInvoice] = useState([]);
  const [DistinctTmpInvoice, setDistinctTmpInvoice] = useState([]);
  const [SeciliFatura, setSeciliFatura] = useState('');
  const [WarehouseAddress, setWarehouseAddress] = useState([]);
  const [FilterLoginInvoice, setFilterLoginInvoice] = useState('')
  const [ImageUrl, setImageUrl] = useState(null)
  const user = getUser();
  const [rows, setRows] = React.useState([]);
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [Barcode, setBarcode] = useState("");
  const [openMaterialFile, setOpenMaterialFile] = React.useState(false);
  const [openMaterialFileTitle, setOpenMaterialFileTitle] = React.useState("");
  const [bultenOpen, setBultenOpen] = React.useState(false);
  const [bultenParam, setBultenParam] = React.useState('');
  const [InvoiceDiffirent, setInvoiceDiffirent] = React.useState([]);
  const [openDifferent, setopenDifferent] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [GeciciButonGorunum, setGeciciButonGorunum] = React.useState(true);
  const [LoadingMaterial, setLoadingMaterial] = React.useState(true);
  const [page, setPage] = React.useState(0);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const likeAudio = new Audio(BarcodeVoice);
  const ErrorAudio = new Audio(ErrorVoice);
  const [selected, setSelected] = React.useState([]);
  const [rowsNotLoginData, setrowsNotLoginData] = React.useState([]);
  const [rowsNotLoginMainData, setrowsNotLoginMainData] = React.useState([]);
  const [isSelectedTmp, setisSelectedTmp] = React.useState("");

  const playSound = audioFile => {
    audioFile.play();
  }
  const handleCloseMaterialFile = () => {
    setOpenMaterialFile(false);
  };
  const handleCloseDifferent = () => {
    setopenDifferent(false);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const handleClickTmp = (event, BelgeNo) => {
    setisSelectedTmp(BelgeNo);
    setLoading(true);
    setPage(0);
    setRowsPerPage(10);
    setGeciciButonGorunum(false);
    let DataParam = [];
    DataParam = rowsNotLoginData.filter(item => sc(item.BelgeNo, BelgeNo.toString()));
    var Faturalar = DataParam[0].Faturalar.toString().split(",");
    var ParamDeger = [];
    Faturalar.forEach(i => {
      ParamDeger = [...ParamDeger, ...DistinctTmpInvoice.filter(item => sc(item.Vbeln, i.toString()))];
    });



    setRows(ParamDeger);

    setSeciliFatura(Faturalar.toString());
    setrowsLogin([]);
    setrowsLogin(DistinctInvoice);
    setLoading(false);
    setSelected([]);

  };
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
    localStorage.setItem('SelectInvoice', newSelected);
    FaturaDetayListele(newSelected);
    setisSelectedTmp("");
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const onChangeSelectWarehouse = (e, valueParam, nameParam, row) => {
    if (!previous[row.Matnr]) {
      setPrevious(state => ({ ...state, [row.Matnr]: row }));
    }
    const value = valueParam;
    const name = nameParam;
    const { Matnr } = row;
    const newRows = rows.map(row => {
      if (row.Matnr === Matnr) {
        return { ...row, [name]: value };
      }
      return row;
    });

    setRows(newRows);

  };

  const onChange = (e, row) => {
    if (!previous[row.Matnr]) {
      setPrevious(state => ({ ...state, [row.Matnr]: row }));
    }
    var value = e.target.value;
    const name = e.target.name;
    if (parseInt(value) < 0) {
      value = 1;
    }
    const { Matnr, Vbeln } = row;
    const newRows = rows.map(row => {
      if (row.Matnr === Matnr && row.Vbeln === Vbeln) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
    localStorage.setItem('InvoiceDetailTmp', JSON.stringify(newRows));
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;


  useEffect(() => {
    FilterLoginInvoice === '' ?
      setrowsLogin(DistinctInvoice) :
      setrowsLogin(DistinctInvoice.filter(item => sc(item.id, FilterLoginInvoice)));
  }, [FilterLoginInvoice, DistinctInvoice]);

  useEffect(() => {
    CreateWareHouseAddress(user.ServiceShopId);
    getMainScreenFull();
  }, []);


  const getMainScreenFull = () => {
    setLoading(true);
    setrowsLogin([]);
    const today = Date.now();
    var BeginDateInvoice = new Date();



    BeginDateInvoice.setDate(BeginDateInvoice.getDate() - user.OpenInvoiceDay);
    //  BeginDateInvoice.setDate(BeginDateInvoice.getDate() - 10);

    var BeginDateInvoiceParam = format(BeginDateInvoice, 'yyyy-MM-dd');


    var EndDateInvoiceParam = format(today, 'yyyy-MM-dd');
    var DegerWarehouseAddress = [];
    DegerWarehouseAddress = GetWarehouseAddress(user.ServiceShopId);
    setWarehouseAddress(DegerWarehouseAddress);

    axios.get(`GetTemporaryInvoiceDetail/${user.ServiceShopId}`)
      .then(response => {
        var DegerTmp = [];
        DegerTmp = response.data;
        const BelgeNoParam = Array.from(new Set(DegerTmp.map(s => s.BelgeNo)))
          .map(BelgeNo => {
            return {
              BelgeNo: BelgeNo,
              Fkdat: DegerTmp.find(s => s.BelgeNo === BelgeNo).Fkdat,
              Faturalar: DegerTmp.find(s => s.BelgeNo === BelgeNo).Faturalar
            };
          });
        setrowsNotLoginMainData(BelgeNoParam);
        setrowsNotLoginData(DegerTmp);
        const DistinctTmpInvoiceParam = Array.from(new Set(DegerTmp.map(s => s.Vbeln)))
          .map(Vbeln => {
            return {
              id: Vbeln,
              Date: DegerTmp.find(s => s.Vbeln === Vbeln).Fkdat,
              Selected: 0
            };
          });
        setDistinctTmpInvoice(DegerTmp);
      }).catch(error => {
      });

    axios.get(`GetInvoiceDetail/${BeginDateInvoiceParam}/${EndDateInvoiceParam}/${user.ServiceShopCode}`)
      .then(response => {
        var Deger = [];
        Deger = response.data;
        var result = [];

        Deger.reduce(function (res, value) {
          if (!res[value.Vbeln + value.Matnr]) {
            res[value.Vbeln + value.Matnr] = {
              Vbeln: value.Vbeln, Matnr: value.Matnr, Maktx: value.Maktx, Fkdat: value.Fkdat, Fkimg: 0
              , DEPO_ADET: value.DEPO_ADET, ADRES_ADET: value.ADRES_ADET
              , WarehouseAddress: value.WarehouseAddress, WarehouseAddressText: value.WarehouseAddressText
            };
            result.push(res[value.Vbeln + value.Matnr])
          }
          res[value.Vbeln + value.Matnr].Fkimg += parseInt(value.Fkimg);
          return res;
        }, {});
        Deger = result;
        Deger = Deger.map((x) => ({
          ...x,
          Count: 0,
          isEditMode: true,
          EndDate: EndDateInvoiceParam
        }));
        setInvoice(Deger);
        const DistinctInvoiceParam = Array.from(new Set(Deger.map(s => s.Vbeln)))
          .map(Vbeln => {
            return {
              id: Vbeln,
              Date: Deger.find(s => s.Vbeln === Vbeln).Fkdat,
              Selected: 0
            };
          });
        setDistinctInvoice(DistinctInvoiceParam);

      }).catch(error => {
      });


    // var LocalDbInvoiceSelect = localStorage.getItem('SelectInvoice');
    // FaturaDetayListele(LocalDbInvoiceSelect);
    setLoading(false);
  }

  const SetBarcodeAddItem = (Barcode) => {
    if (Barcode === "") {
      return;
    }
    //serdar
    var Varmi = rows.filter(d => d.Matnr.replace(/^0+/, '') === Barcode);
    if (Varmi.length === 0) {
      playSound(ErrorAudio);
      axios.get('GetMaterialDescription/' + Barcode)
        .then(response => {
          if (response.data === "") {
            setBarcode("");
            return;
          }

          confirmAlert({
            message: Barcode + " " + response.data + "  faturada olmayan malzemeyi ekleyemezsiniz!",
            buttons: [
              {
                label: 'Tamam',
                onClick: () => { return; }
              }
            ]
          });


        }).catch(error => {
          alert("hata");
        })
      return;
    }

    Varmi = rows.filter(d => d.Matnr.replace(/^0+/, '') === Barcode && parseInt(d.Fkimg, 10) > d.Count);
    setLoading(true);
    var rowsParam = [...rows.map(item => ({
      ...item,
      isEditMode: true
    }))];
    var KontrolIndex;
    if (Varmi.length > 0) {
      var rowsParamIndex = rows.findIndex(d => d.Matnr.replace(/^0+/, '') === Barcode && parseInt(d.Fkimg, 10) > d.Count);
      rowsParam[rowsParamIndex].Count = parseInt(rowsParam[rowsParamIndex].Count) + 1;
      rowsParam[rowsParamIndex].isEditMode = false;
      KontrolIndex = rowsParamIndex;
    } else {
      var rowsParamIndexKontrol = rowsParam.findIndex(d => d.Matnr.replace(/^0+/, '') === Barcode);
      rowsParam[rowsParamIndexKontrol].Count = parseInt(rowsParam[rowsParamIndexKontrol].Count) + 1;
      rowsParam[rowsParamIndexKontrol].isEditMode = false;
      KontrolIndex = rowsParamIndexKontrol;
    }
    setRows(rowsParam);
    localStorage.setItem('InvoiceDetailTmp', JSON.stringify(rowsParam));
    playSound(likeAudio);
    setLoading(false);
    setBarcode("");
  }

  const faturaYeniMalzemeEkle = (Barcode, Aciklama) => {
    var FaturaNo = rows[0].Vbeln;
    var EndDate = rows[0].EndDate;
    var Fkdat = rows[0].Fkdat;

    axios.get(`GetDepoAdetFiyat/${Barcode}/${user.ServiceShopId}/${user.TechnicianId}`)
      .then(response => {
        var DepoAdet = response.data.split('|')[0];
        var KdvliFiyat = response.data.split('|')[1];
        var ADRES_ADET = response.data.split('|')[2];
        var WarehouseAddressText = response.data.split('|')[3];
        var WarehouseAddress = response.data.split('|')[4];
        var item = {
          Count: 1,
          EndDate: EndDate,
          Fkdat: Fkdat,
          Fkimg: 0,
          Maktx: Aciklama,
          Matnr: Barcode,
          Vbeln: FaturaNo,
          WarehouseAddress: WarehouseAddress,
          ADRES_ADET: ADRES_ADET,
          WarehouseAddressText: WarehouseAddressText,
          DEPO_ADET: DepoAdet,
          isEditMode: false
        }

        var YeniDeger = rows;
        YeniDeger.push(item);
        setRows(YeniDeger);

        var LocalDeger = [];
        LocalDeger = GetLocalInvoice();
        LocalDeger.push(item);
        localStorage.removeItem('InvoiceDetail');
        localStorage.setItem('InvoiceDetail', JSON.stringify(LocalDeger));
        getMainScreenFull();
        setBarcode("");
      }
      ).catch(error => {
        console.log(error);
      })



  }

  const SetFaturaMalzemeCikar = (event, Vbeln, Matnr) => {
    confirmAlert({
      message: "Malzeme faturadan çıkartılacaktır!... Devam etmek istediğinizden emin misiniz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => { SetFaturaMalzemeCikarKabul(event, Vbeln, Matnr); }
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  }
  const SetFaturaMalzemeCikarKabul = (event, Vbeln, Matnr) => {
    var RowParam = [...rows];

    var filteredRowIndex = RowParam.findIndex(x => x.Vbeln === Vbeln && x.Matnr === Matnr);
    RowParam.splice(filteredRowIndex, 1);
    setRows(RowParam);

    var InvoiceParam = [...Invoice];
    var filteredInvoiceIndex = InvoiceParam.findIndex(x => x.Vbeln === Vbeln && x.Matnr === Matnr);
    InvoiceParam.splice(filteredInvoiceIndex, 1);
    setInvoice(InvoiceParam);

    var LocalDeger = [];
    LocalDeger = GetLocalInvoice();
    var filteredLocalIndex = LocalDeger.findIndex(x => x.Vbeln === Vbeln && x.Matnr === Matnr);
    LocalDeger.splice(filteredLocalIndex, 1);
    localStorage.setItem('InvoiceDetail', JSON.stringify(LocalDeger));// // MainScreenFull();
  }

  const GirisYapDetay = (event, Tip) => {

    if (Tip === 3) {
      setInvoiceDiffirent(rows.filter(d => parseInt(d.Count) !== parseInt(d.Fkimg)));
      setopenDifferent(true);
      return;
    }
    var LocalDbInvoice = JSON.parse(localStorage.getItem('InvoiceDetailTmp'));

    setLoading(true);
    const data = rows.map(item => ({
      ServiceShopId: user.ServiceShopId
      , UserId: user.OrganizationUserId
      , MaterialCode: item.Matnr.replace(/^0+/, '')
      , InvoiceCount: parseInt(item.Fkimg, 10)
      , Count: item.Count
      , WarehouseAddress: item.WarehouseAddress
      , InvoiceNr: item.Vbeln
      , InvoiceDate: item.Fkdat
      , Type: Tip
    }));

    const config = {
      headers: { 'Content-Type': 'application/json' }
    }

    rows.forEach(h => {
      var filteredRowIndex = LocalDbInvoice?.findIndex(d => d.Vbeln === h.Vbeln);
      if (filteredRowIndex !== undefined) {
        LocalDbInvoice.splice(filteredRowIndex, 1);
      }
    });
    localStorage.setItem('InvoiceDetailTmp', JSON.stringify(LocalDbInvoice));


    axios.post('/SetInvoiceSendtoCenter', data, config)
      .then(response => {
        setLoading(false);
        let ResponseData = response.data[0];
        setUyariTip("success");
        setSeciliFatura('');
        setUyariAciklama(ResponseData.ErrorDescription);
        setUyari(true);
        getMainScreenFull();
        setRows([]);

      });
  }

  const GirisYap = (event, Tip) => {

    if (SeciliFatura.toString() === "") {
      setUyariTip("error");
      setUyariAciklama("Lütfen fatura seçimi yapınız!...");
      setUyari(true);
      return;
    }

    var AlınanAdetKontrolu = rows.filter(item => item.Fkimg < item.Count);
    if (AlınanAdetKontrolu.length > 0) {
      setUyariTip("error");
      setUyariAciklama("Fatura adetinden yüksek giriş yapılamaz. Lütfen alınan adet değerlerinizi kontrol ediniz! ");
      setUyari(true);
      return;
    }

    var AdresKontrol = rows.filter(d => parseInt(d.WarehouseAddress) === parseInt(0) && parseInt(d.Count) > 0);

    var Uyari = "";
    if (Tip === 1) {
      Uyari = "Geçici giriş yapmak istediginizden emin misiniz?";
      if (AdresKontrol.length > 0) {
        setUyariTip("error");
        setUyariAciklama("Adres seçimi yapılmayan malzemeler bulunuyor!... Lütfen adres seçiniz!...");
        setUyari(true);
        return;
      }
    }
    if (Tip === 2) {
      Uyari = "Kesin giriş yapmak istediginizden emin misiniz?";
      if (AdresKontrol.length > 0) {
        setUyariTip("error");
        setUyariAciklama("Adres seçimi yapılmayan malzemeler bulunuyor!... Lütfen adres seçiniz!...");
        setUyari(true);
        return;
      }
    }
    if (Tip === 3) {
      Uyari = "Farkları göstermek istediginizden emin misiniz?";
    }

    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => GirisYapDetay(event, Tip)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });

  }
  const fncFaturaElleAdetKullanOperation = (event, Tip) => {
    if (Tip === 1) {
      setRows(rows.map(item => ({
        ...item,
        Count: parseInt(item.Fkimg, 10)
      }
      )));

      localStorage.setItem('InvoiceDetailTmp', JSON.stringify(rows.map(item => ({
        ...item,
        Count: parseInt(item.Fkimg, 10)
      }
      ))));

    }
    if (Tip === 2) {
      setRows(rows.map(item => ({
        ...item,
        Count: 0
      }
      )));
      localStorage.setItem('InvoiceDetailTmp', JSON.stringify(rows.map(item => ({
        ...item,
        Count: 0
      }
      ))));
    }


  }
  const fncFaturaElleAdetKullan = (event, Tip) => {


    if (SeciliFatura.toString() === "") {
      setUyariTip("error");
      setUyariAciklama("Lütfen fatura seçimi yapınız!...");
      setUyari(true);
      return;
    }


    var Uyari = "";
    if (Tip === 1) {
      Uyari = "Giriş yapılan adetler fatura adetleri ile değiştirilecektir!... Devam istediginizden emin misiniz?";

    }
    if (Tip === 2) {
      Uyari = "Fatura adetleri silenecektir!... Devam istediginizden emin misiniz?";

    }
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => fncFaturaElleAdetKullanOperation(event, Tip)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });

  }
  const MerkezdenTekrarAlIslem = (event) => {
    SaveLocalInvoiceAddress(user.UserId, user.SessionToken,
      user.ServiceShopCode, user.ServiceShopId,
      user.TechnicianId);
    setLoading(true);
    getMainScreenFull();
    setRows([]);
    setSeciliFatura('');
    setLoading(false);
  }
  const MerkezdenTekrarAl = (event) => {
    confirmAlert({
      message: "Merkezden fatura ve adres verileri tekrar alınacaktır!... Devam etmek istediğinizden emin misiniz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => MerkezdenTekrarAlIslem(event)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });

  }

  const GetMaterialImage = (event, materialCode) => {
    setOpenMaterialFile(true);
    setLoadingMaterial(true);
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    setOpenMaterialFileTitle(materialCode + " Numaralı Malzeme Detayı");
    axios.get(`MaterialFile/${materialCode}`, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        setImageUrl(fileURL);
        setLoadingMaterial(false);
      }).catch(error => {
        setLoadingMaterial(false);
      });
  }
  const GetMaterialBulletin = (event, materialCode) => {
    setBultenParam(materialCode);
    setBultenOpen(true);
  }

  const FaturaDetayListele = (FaturaNo) => {
    var LocalDbInvoice = JSON.parse(localStorage.getItem('InvoiceDetailTmp'));
    setLoading(true);
    setGeciciButonGorunum(true);
    setPage(0);
    setRowsPerPage(10);
    console.log(LocalDbInvoice);
    if (FaturaNo.toString() === "") {
      setRows([]);
    } else {
      setLoading(true);
      var Faturalar = FaturaNo.toString().split(",");
      var ParamDeger = [];
      Faturalar.forEach(i => {

        if (LocalDbInvoice != null) {
          var Varmi = LocalDbInvoice.filter(item => sc(item.Vbeln, i.toString()));
          if (Varmi.length > 0) {
            ParamDeger = [...ParamDeger, ...Varmi];
          } else {
            ParamDeger = [...ParamDeger, ...Invoice.filter(item => sc(item.Vbeln, i.toString()))];
          }
        }
        else {
          ParamDeger = [...ParamDeger, ...Invoice.filter(item => sc(item.Vbeln, i.toString()))];
        }


      });
      setRows(ParamDeger);

    }



    setSeciliFatura(FaturaNo.toString());
    // setrowsNotLogin([]);
    // setrowsNotLogin(DistinctTmpInvoiceParamYedek);

    setLoading(false);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };


  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const headCells = [
    { id: 'id', numeric: false, disablePadding: true, label: 'FaturaNo' },
    { id: 'Date', numeric: true, disablePadding: true, label: 'Tarih' },
  ];


  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            {/* <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{ 'aria-label': 'select all desserts' }}
            /> */}
          </TableCell>
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={'left'}
              padding={headCell.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {/* {order === 'desc' ? '' : ''} */}
                    {''}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  const search = "";

  const setAdres = (param, index, MALZEME_STOK_NO) => {

    axios.get(`/GetAdresMalzemeKullanilabilirAdet/${user.ServiceShopId}/${param?.Id || 0}/${MALZEME_STOK_NO}`)
      .then(response => {
        console.log(index);
        let old_rows = [...rows];
        old_rows[index].WarehouseAddress = param?.Id || 0;
        old_rows[index].WarehouseAddressText = param?.Description || 0;
        old_rows[index].Malzemeleri = param?.Materials || 0;
        old_rows[index].ADRES_ADET = response.data;
        setRows(old_rows);
        localStorage.setItem('InvoiceDetailTmp', JSON.stringify(old_rows));
      })
      .catch(error => {
        console.log(error);
      });
  }
  const setAdresSol = (param, index, MALZEME_STOK_NO) => {

    axios.get(`/GetAdresMalzemeKullanilabilirAdet/${user.ServiceShopId}/${param.Id}/${MALZEME_STOK_NO}`)
      .then(response => {
        let old_rows = [...InvoiceDiffirent];
        old_rows[index].WarehouseAddress = param?.Id || 0;
        old_rows[index].WarehouseAddressText = param?.Description || 0;
        old_rows[index].Malzemeleri = param?.Materials || 0;
        old_rows[index].ADRES_ADET = response.data;
        setInvoiceDiffirent(old_rows);
        localStorage.setItem('InvoiceDetailTmp', JSON.stringify(old_rows));
      })
      .catch(error => {
        console.log(error);
      });
  }



  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Backdrop className={classes.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="oasis Yönetimi Faturaya İstinaden Giriş"
            action={
              <IconButton
                onClick={(event) => MerkezdenTekrarAl(event)}
                color="primary">
                <UpdateIcon />
              </IconButton>
            }
          />
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={3}>
                <Paper>
                  <CardHeader title="Giriş Yapılmamış Faturalar" />
                  <Divider />
                  <CardActions>
                    <FormControl fullWidth className={classes.margin}>
                      <TextField
                        label="Fatura Numarası"
                        id="standard-start-adornment"
                        className={clsx(classes.margin, classes.textField)}
                        onChange={event => { setFilterLoginInvoice(event.target.value) }}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>,
                        }}
                      />
                    </FormControl>
                  </CardActions>
                  <TableContainer style={{ height: 250, width: '100%' }}>
                    <Table
                      className={classes.table}
                      aria-labelledby="tableTitle"
                      size={'small'}
                    >
                      <EnhancedTableHead
                        classes={classes}
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={handleSelectAllClick}
                        onRequestSort={handleRequestSort}
                        rowCount={rows.length}
                      />
                      <TableBody>
                        {stableSort(rowsLogin, getComparator(order, orderBy))
                          .map((row, index) => {
                            const isItemSelected = isSelected(row.id);
                            const labelId = `enhanced-table-checkbox-${index}`;
                            return (
                              <TableRow
                                hover
                                onClick={(event) => handleClick(event, row.id)}
                                role="checkbox"
                                aria-checked={isItemSelected}
                                tabIndex={-1}
                                key={row.id}
                                selected={isItemSelected}
                              >
                                <TableCell padding="checkbox">
                                  <Checkbox
                                    checked={isItemSelected}
                                    color="primary"
                                    inputProps={{ 'aria-labelledby': labelId }}
                                  />
                                </TableCell>
                                <TableCell id={labelId} scope="row" padding="none">
                                  {row.id}
                                </TableCell>
                                <TableCell>{row.Date}</TableCell>
                              </TableRow>
                            );
                          })}

                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
                <br />
                <Paper>
                  <CardHeader title="Geçiçi Giriş Yapılmış Faturalar" />
                  <Divider />
                  <TableContainer style={{ height: 250, width: '100%' }}>
                    <Table
                      className={classes.table}
                      aria-labelledby="tableTitle"
                      size={'small'}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell padding="checkbox"></TableCell>
                          <TableCell align="left">BelgeNo</TableCell>
                          <TableCell align="left">Faturalar</TableCell>
                          <TableCell align="left">Tarih</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rowsNotLoginMainData
                          // .sort(s => isSelected(s.BelgeNo) ? -1 : 1)
                          .map((row, index) => {
                            // const isItemSelectedTmp = isSelectedTmp(row.BelgeNo);
                            const labelIdTmp = `enhanced-table-checkbox-${index}`;
                            return (
                              <TableRow
                                hover
                                onClick={(event) => handleClickTmp(event, row.BelgeNo)}
                                role="Radio"

                                tabIndex={-1}
                                key={row.BelgeNo}
                              // selected={isItemSelectedTmp}
                              >
                                <TableCell padding="Radio">
                                  <Radio
                                    checked={isSelectedTmp === row.BelgeNo}
                                    color="primary"
                                    inputProps={{ 'aria-labelledby': labelIdTmp }}
                                  />
                                </TableCell>
                                <TableCell id={labelIdTmp} scope="row" align="left" padding="none">
                                  {row.BelgeNo}
                                </TableCell>
                                <TableCell id={labelIdTmp} scope="row" align="left" padding="none">
                                  {row.Faturalar}
                                </TableCell>
                                <TableCell align="left">{row.Fkdat}</TableCell>
                              </TableRow>
                            );
                          })}

                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={9}>
                <Paper>
                  <CardActions>
                    <div>
                      {
                        GeciciButonGorunum ?
                          <Button
                            variant="contained"
                            className={classes.button}
                            color="secondary"
                            endIcon={<GiTemporaryShield></GiTemporaryShield>}
                            onClick={(event) => GirisYap(event, 1)}
                          >
                            Geçİcİ Gİrİş
                          </Button>
                          : ''
                      }
                      <Button
                        variant="contained"
                        className={classes.button}
                        color="secondary"
                        endIcon={<FiSend>Onizleme</FiSend>}
                        onClick={(event) => GirisYap(event, 2)}
                      >
                        Kesİn Gİrİş
                      </Button>
                      <Button
                        variant="contained"
                        className={classes.button}
                        color="secondary"
                        endIcon={<BsFileDiff>Onizleme</BsFileDiff>}
                        onClick={(event) => GirisYap(event, 3)}
                      >
                        Farklar
                      </Button>
                      <Button
                        variant="contained"
                        className={classes.button}
                        color="secondary"
                        endIcon={<DomainIcon>Onizleme</DomainIcon>}
                        onClick={(event) => fncFaturaElleAdetKullan(event, 1)}
                      >
                        Alınan Adetlerİ Fatura Adedİne Eşİtle
                      </Button>
                      <Button
                        variant="contained"
                        className={classes.button}
                        color="secondary"
                        endIcon={<TouchAppIcon>Onizleme</TouchAppIcon>}
                        onClick={(event) => fncFaturaElleAdetKullan(event, 2)}
                      >
                        Gİrİş Adetlerİnİ Sıfırla
                      </Button>
                    </div>
                  </CardActions>
                  <Divider />
                  <Snackbar open={uyari} autoHideDuration={6000}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    onClose={uyariKapat}>
                    <Alert onClose={uyariKapat} severity={uyariTip}>
                      {uyariAciklama || ''}
                    </Alert>
                  </Snackbar>
                  <CardHeader title={SeciliFatura.toString() + ' Numaralı Fatura Detayı'}></CardHeader>
                  <Divider />
                  <CardActions>
                    <FormControl fullWidth className={classes.margin}>
                      <TextField
                        label="Barkod"
                        id="standard-start-adornment"
                        value={Barcode}
                        name={Barcode}
                        className={clsx(classes.margin, classes.textField)}
                        onChange={event => { setBarcode(event.target.value) }}
                        onKeyPress={event => {
                          if (event.key === 'Enter') {
                            SetBarcodeAddItem(event.target.value)
                          }
                        }}
                        InputProps={{
                          endAdornment: <InputAdornment position="end"><CropFreeIcon /></InputAdornment>,
                        }}
                      />
                    </FormControl>
                  </CardActions>
                  <Divider />
                  <TableContainer className={classes.container}>
                    <Table className={classes.table} size="small"
                      stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" padding='none'>FaturaNo</TableCell>
                          <TableCell align="left" padding='none'>MalzemeStokNo</TableCell>
                          <TableCell align="left" padding='none'>Malzeme</TableCell>
                          <TableCell align="left" padding='none'>DepoAdet</TableCell>
                          <TableCell align="left" padding='none'>AdresAdet</TableCell>
                          <TableCell align="left" padding='none'>FaturaAdet</TableCell>
                          <TableCell align="center" padding='none'>AlınanAdet</TableCell>
                          <TableCell align="center" padding='none' width="200">Adres</TableCell>
                          <TableCell align="center" padding='none'>Resim</TableCell>
                          <TableCell align="center" padding='none'>Bülten</TableCell>
                          <TableCell align="center" padding='none'>Sil</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows.sort(({ isEditMode: previousID }, { isEditMode: currentID }) => previousID - currentID)
                          .map((row, index) => (
                            <TableRow key={index} style={parseInt(row.Fkimg, 10) === 0 ? { background: "#fdffe0" } : {}}>
                              <TableCell align="center" padding='none' className={classes.tableCell}>
                                {row.Vbeln}
                              </TableCell>
                              <TableCell align="left" padding='none' className={classes.tableCell}>
                                {row.Matnr.replace(/^0+/, '')}
                              </TableCell>
                              <TableCell align="left" padding='none' title={row.Maktx} className={classes.tableCell}>
                                {row.Maktx.substring(0, 20)}...
                              </TableCell>
                              <TableCell align="center" padding='none' className={classes.tableCell}>
                                {parseInt(row.DEPO_ADET, 10)}
                              </TableCell>
                              <TableCell align="center" padding='none' className={classes.tableCell}>
                                {parseInt(row.ADRES_ADET, 10)}
                              </TableCell>
                              <TableCell align="center" padding='none' className={classes.tableCell}>
                                {parseInt(row.Fkimg, 10)}
                              </TableCell>
                              <CustomTableCell {...{ row, name: "Count", onChange, Adet: parseInt(row.Fkimg, 10) }} />
                              <TableCell padding='none' align="left" className={classes.tableCell}>
                                <AddressSearch
                                  setAdres={setAdres}
                                  value={{
                                    Id: row.WarehouseAddress || '0',
                                    Description: row.WarehouseAddressText || 'Adres Seçiniz!...',
                                    Materials: row.Malzemeleri | ''
                                  } || ''}
                                  searchParam={search}
                                  MaterialCode={row.Matnr.replace(/^0+/, '')}
                                  ServicePaperNr={1}
                                  index={index}
                                  Adres={row.WarehouseAddress || 0}
                                  RowSelected={row.KONTROL_ADRES}
                                  Tip={"Giris"}
                                />
                              </TableCell>
                              <TableCell align="center" padding='none' className={classes.tableCell}>
                                <ImageSearchIcon
                                  onClick={(event) => GetMaterialImage(event, row.Matnr.replace(/^0+/, ''))}
                                  color="primary" />
                              </TableCell>
                              <TableCell align="center" padding='none' className={classes.tableCell}>
                                <FindInPageIcon
                                  onClick={(event) => GetMaterialBulletin(event, row.Matnr.replace(/^0+/, ''))}
                                  color="primary" />
                              </TableCell>
                              <TableCell align="center" padding='none' className={classes.tableCell}>
                                {
                                  parseInt(row.Fkimg, 10) === 0 ?
                                    <DeleteForeverIcon
                                      onClick={(event) => SetFaturaMalzemeCikar(event, row.Vbeln, row.Matnr)}
                                      color="error" />
                                    : ""
                                }
                              </TableCell>

                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={bultenOpen}
        onClose={() => setBultenOpen(false)}
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle id="alert-dialog-title">
          Malzemeye Ait Bültenler
        </DialogTitle>
        <DialogContent>
          {LoadingMaterial ? <LinearProgress
            status="loading"
          /> : <GenericBulten param={bultenParam} />}

        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setBultenOpen(false)}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openMaterialFile}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseMaterialFile}      >
        <DialogTitle>
          {openMaterialFileTitle}
        </DialogTitle>
        <DialogContent>
          {LoadingMaterial ? <LinearProgress
            status="loading"
          /> : <img style={{ width: '100%' }} alt='' src={ImageUrl} />}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMaterialFile} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDifferent}
        TransitionComponent={Transition}
        keepMounted
        fullWidth={true}
        maxWidth={'lg'}
        onClose={handleCloseDifferent}      >
        <DialogTitle>
          Fatura Malzeme Sayım Farkı
        </DialogTitle>
        <DialogContent>
          <TableContainer>
            <Table size="small"
              stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="left">MalzemeStokNo</TableCell>
                  <TableCell align="left">Malzeme</TableCell>
                  <TableCell align="left">FaturaAdet</TableCell>
                  <TableCell align="center">AlınanAdet</TableCell>
                  <TableCell align="center" width="200">Adres</TableCell>
                  <TableCell>Resim</TableCell>
                  <TableCell>Bülten</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {InvoiceDiffirent.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="left" className={classes.tableCell}>
                      {row.Matnr.replace(/^0+/, '')}
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      {row.Maktx}
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      {parseInt(row.Fkimg, 10)}
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      {parseInt(row.Count, 10)}
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      <AddressSearch
                        setAdres={setAdresSol}
                        value={{
                          Id: row.WarehouseAddress || '0',
                          Description: row.AdresAciklama || 'Adres Seçiniz!...',
                          Materials: row.Malzemeleri | ''
                        } || ''}
                        searchParam={search}
                        MaterialCode={row.Matnr.replace(/^0+/, '')}
                        ServicePaperNr={1}
                        index={index}
                        Adres={row.WarehouseAddress || 0}
                        RowSelected={1}
                        Tip={"Giris"}
                      />
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      <ImageSearchIcon
                        onClick={(event) => GetMaterialImage(event, row.Matnr.replace(/^0+/, ''))}
                        color="primary" />
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      <FindInPageIcon
                        onClick={(event) => GetMaterialBulletin(event, row.Matnr.replace(/^0+/, ''))}
                        color="primary" />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDifferent} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default LoginInvoice;
